$(document).ready(function () {

    var send = new BigNumber($("#send_amount").val());
    var receive = new BigNumber($("#receive_amount").val());
    var rate = new BigNumber($("#rate").val());
    var rate_uuid = $("#rate_uuid").val();
    var min = 0;
    var max = 0; // when to trigger fetch
    var fetch_date;
    var fee = BigNumber(0); // 0%
    var feeAmount = BigNumber(0); // 0%
    var conversionAmount = 0;
    var payableAmount = BigNumber(0);
    var voucherAmount = BigNumber(0);
    var hasApplicableVoucher = false;

    var sendCurr;
    var receiveCurr;

    var transaction;

    var errors = [];

    var btnContinueDefaultLabel = $("#btn-continue").val();

    // first open
    if ($('#form-amount').length) {
        fetchRate(function () {
            convertSendToReceive();
            convertDineros();
        });
    }

    /**
     * Fetches rate from API
     * @param callback is executed on successful fetch. Recalculates all amounts based on new rate
     */
    function fetchRate(callback) {
        $("#btn-continue").prop("disabled", true);
        $("#btn-continue").val("Converting...");

        $.ajax({
            type: 'POST',
            url: '/api/v1/currency/convert',
            data: $("#form-amount").serializeArray(),

            success: function (data) {
                clearErrors()

                transaction = data.transaction;

                rate = new BigNumber(transaction.rate)
                rate_uuid = transaction.conversionRate.uuid
                send = new BigNumber(transaction.send_amount)
                receive = new BigNumber(transaction.receive_amount)
                fee = new BigNumber(transaction.fee);
                feeAmount = new BigNumber(transaction.fee_amount);
                conversionAmount = new BigNumber(transaction.send_amount_with_fee);
                payableAmount = new BigNumber(transaction.payable_amount);
                voucherAmount = new BigNumber(transaction.voucher_amount);
                hasApplicableVoucher = transaction.has_applicable_voucher;

                fetch_date = new Date(Date.parse(transaction.conversionRate.updated_at.replace(/-/g, '/')))

                sendCurr = $("#sendCurrency").val();
                receiveCurr = $("#receiveCurrency").val();

                // add new updated fees
                var selectedIndex = $("[name=converter_fee]").prop('selectedIndex');

                $("[name=converter_fee]").empty();
                $.each(data.fees, function (index, value) {
                    var o = new Option(value.text, value.value);
                    $(o).html(value.text);
                    $("[name=converter_fee]").append(o);
                });
                $("[name=converter_fee]").prop('selectedIndex', selectedIndex)
                $("[name=converter_fee]").selectpicker('refresh');

                // handle voucher
                updateVoucherViews();

                callback()
            },

            error: function (data) {
                var errors = $.parseJSON(data.responseText);
                showErrors(errors.errors);
            }
        });
    }

    function updateVoucherViews() {
        if (hasApplicableVoucher) {
            $('.tl-voucher-to-be-applied').show()

            if (voucherAmount > 0) {
                $('.tl-voucher-applied').show()
                $('.tl-voucher-to-be-applied').hide()

                $('.tl-send-amount').addClass('text-strikethrough')
            }
            else {
                $('.tl-voucher-applied').hide()
                $('.tl-voucher-to-be-applied').show()
                $('.tl-send-amount').removeClass('text-strikethrough')
            }
        }
        else
            $('.tl-voucher-to-be-applied').hide()
    }

    function convertDineros() {
        $("#btn-continue").prop("disabled", true);
        $("#btn-continue").val("Converting...");


        var sendFormatter = getFormatter(sendCurr);
        var receiveFormatter = getFormatter(receiveCurr);
        var rateFormatter = getFormatter(receiveCurr, 4, true);

        var rateF = rateFormatter.format(rate),
            sendF = sendFormatter.format(send),
            receiveF = receiveFormatter.format(receive);

        // update info box //
        $("#you-exchange").html(sendF + " " + sendCurr)
        //$("#conversion-amount").html(conversionAmount.toFixed(2) + " " + sendCurr)
        $("#conversion-amount").html(sendFormatter.format(conversionAmount) + " " + sendCurr);
        $("#fee-amount").html(sendFormatter.format(feeAmount) + " " + sendCurr)
        $("#exchange-details").html(sendCurr + "/" + receiveCurr + " " + rateF)
        $("#you-receive").html(receiveF + " " + receiveCurr)
        $("#fetch-date").html(fetch_date.toLocaleString("en-UK"))

        // voucher //
        $("#you-exchange-with-voucher").html(sendFormatter.format(payableAmount) + " " + sendCurr)

        // update inputs //
        $("#rate_uuid").val(rate_uuid);

        $("#btn-continue").prop("disabled", false);
        $("#btn-continue").val(btnContinueDefaultLabel);
    }

    function convertSendToReceive() {
        var receiveFormatter = getFormatter(receiveCurr, 2, true);
        $("#receive_amount").val(receiveFormatter.format(receive));
    }

    function convertReceiveToSend() {
        var sendFormatter = getFormatter(receiveCurr, 2, true);
        $("#send_amount").val(sendFormatter.format(send));
    }

    $("#send_amount").on("keyup", function () {
        delay(function () {
            // set direction of conversion
            $("#convert_send_to_receive").val(1)

            fetchRate(function () {
                convertSendToReceive();
                convertDineros();
            });

        }, 500);
    });

    $("#receive_amount").on("keyup", function () {
        delay(function (e) {
            // set direction of conversion
            $("#convert_send_to_receive").val(0)

            fetchRate(function () {
                convertReceiveToSend();
                convertDineros();
            });

        }, 500);
    });

    $("[name=send_currency]").change(function () {
        // set direction of conversion
        $("#convert_send_to_receive").val(1)

        fetchRate(function () {
            convertSendToReceive();
            convertDineros();
        });
    })

    $("[name=receive_currency]").change(function () {
        // set direction of conversion
        $("#convert_send_to_receive").val(0)

        fetchRate(function () {
            convertReceiveToSend();
            convertDineros();
        });
    })

    $("[name=converter_fee]").change(function () {

        fetchRate(function () {
            $("#convert_send_to_receive").val() == "1" ? convertSendToReceive() : convertReceiveToSend();
            convertDineros();
        });
    })

    // errors
    function showErrors(errors) {
        clearErrors();
        clearForm();
        $.each(errors, function (key, value) {
            $('.transaction-errors').show();
            $('.transaction-errors').append('<p>' + value + '</p>');

            $("#btn-continue").prop("disabled", true);
            $("#btn-continue").val(btnContinueDefaultLabel);
        });
    }

    function clearErrors() {
        $('.transaction-errors').hide()
        $('.transaction-errors').empty()
        return
    }

    function clearForm() {
        $("#convert_send_to_receive").val() == "1" ? $("#receive_amount").val('') : $("#send_amount").val('')

        $("#you-exchange").html('');
        $("#conversion-amount").html('');
        $("#fee-amount").html('');
        $("#exchange-details").html('');
        $("#you-receive").html('');
        $("#fetch-date").html('');

        // voucher //
        $("#you-exchange-with-voucher").html('');
    }

    var timer = 0;
    function delay(callback, ms) {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    }

    // attach this code to all inputs that handle currencies
    $(".currency-input").on("keydown", function (e) {
        var keycode = (event.which) ? event.which : event.keyCode;

        if (e.shiftKey == true) return false;
        if ([8, 110, 39, 37, 46].indexOf(keycode) >= 0 || // allow tab, dot, left and right arrows, delete keys
            (keycode == 190 && this.value.indexOf('.') === -1) || // allow dot if not exists in the value
            (keycode == 110 && this.value.indexOf('.') === -1) || // allow dot if not exists in the value
            (keycode >= 48 && keycode <= 57) || // allow numbers
            (keycode >= 96 && keycode <= 105)) { // allow numpad numbers
            // check for the decimals after dot and prevent any digits
            var parts = this.value.split('.');
            if (parts.length > 1 && // has decimals
                parts[1].length >= 2 && // should limit this
                (
                    (keycode >= 48 && keycode <= 57) || (keycode >= 96 && keycode <= 105)
                ) // requested key is a digit
            ) {
                return true;
            } else {
                if (keycode == 110) {
                    this.value += ".";
                    return false;
                }
                return true;
            }
        } else {
            return false;
        }
    }).on("keyup", function () {
        var parts = this.value.split('.');
        parts[0] = parts[0].replace(/,/g, '').replace(/^0+/g, '');
        if (parts[0] == "") parts[0] = "0";
        var calculated = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        if (parts.length >= 2) calculated += "." + parts[1].substring(0, 2);
        this.value = calculated;
        if (this.value == "NaN" || this.value == "") this.value = 0;
    });
})

function getFormatter(forCurrency, decimalPlaces = 2, hideCurrency = true) {

    return new Intl.NumberFormat('en-US', {
        style: hideCurrency ? 'decimal' : 'currency',
        currency: forCurrency,
        currencyDisplay: 'code',
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces

        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });
}

// CSRF setup
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

// AJAX loaders //
$(document).ajaxStart(function () {
    $(".ajax-loader").fadeIn();
});

$(document).ajaxComplete(function () {
    $(".ajax-loader").fadeOut();
});

//disable pasting
document.addEventListener('DOMContentLoaded', () => {
    const myInput = document.getElementById('send_amount');
    const myInput2 = document.getElementById('receive_amount');

    if (myInput) myInput.onpaste = e => e.preventDefault();
    if (myInput2) myInput2.onpaste = e => e.preventDefault();
});
